const message = {
  hello: 'Bonjour {name}',
  evolution: 'Evolution',
  from: 'De',
  to: 'Justqu\'',
  vitamins: 'Vitamines',
  for: 'Pour',
  current: 'Actuellement',
  current_value: 'Valeur actuelle',
  team: 'Équipe',
  average: 'Moyenne',
  median: 'Médian',
  company: 'Entreprise',
  score: 'Score',
  new: 'Nieuw',
  activity_log: 'Journal d\'activités',
  dashboard: 'Tableau de bord',
  sign_out: 'Déconnecter',
  preferences: 'Préférences',
  light_mode: 'Mode lumineux ',
  dark_mode: 'Mode noir',
  manager: 'Manager',
  hr: 'RH',
  company_settings: 'Paramètres de l\'entreprise',
  continue: 'continuer',
  no: 'Non',
  finalized: 'Finalisé',
  reviewed: 'Révisé',
  draft: 'Le brouillon',
  show_previous_score: 'Voir votre scores précédents',
  next_page: 'Page suivante',
  previous_page: 'Page précédente',
  save_draft: 'Sauver le brouillon',
  finalize: 'Finaliser',
  current_score: 'Score actuel',
  previous_score: 'Score précédent',
  team_average: 'La moyenne de l\'équipe',
  company_average: 'La moyenne de l\'entreprise',
  comments_questions: 'Observations/Questions',
  overview: 'Aperçu',
  step: 'Étappe',
  introduction: 'Introduction',
  please_complete_the_following_steps_to_begin: 'Gelieve de volgende stappen te doorlopen om te beginnen.',
  next: 'Suivant',
  back: 'Retourner',
  previous: 'Vorige',
  skip_setup: 'Sauter les étapes de configurations',
  server_setup: 'Étapes de configurations',
  server_url: 'L\'URL du serveur',
  port: 'Port',
  test_connection: 'Controller la connection',
  connection_ok: 'Connection OK!',
  my_profile: 'Mon profil',
  personal: 'Donées personnelles',
  contact: 'Contact',
  account: 'Compte',
  tags: 'Marqueurs',
  perks: 'Privilèges',
  first_name: 'Prénom',
  last_name: 'Nom',
  birthdate: 'Date de naissance',
  gender: 'Sexe',
  marital_state: 'État civil',
  degree: 'Niveau d\'instruction',
  mode_of_transportation: 'Mode de transport',
  add_child: 'Ajouter un enfant',
  child_name: 'Nom de l\'enfant',
  age: 'Age',
  actions: 'Actions',
  save_user: 'Sauvegarder l\'utilisateur',
  male: 'Homme',
  female: 'Femme',
  other: 'Autre',
  not_married: 'Ne pas marié',
  married: 'Marié',
  divorced: 'Divorcé',
  widowed: 'Veuve/Veuf',
  choose: 'Sélectionner',
  primary: 'École primaire',
  secondary: 'École secondaire',
  bachelor: 'Baccalauréat',
  master: 'Master',
  doctorate: 'Doctorat',
  car: 'Voiture',
  bike: 'Vélo',
  foot: 'À pied',
  public_transportation: 'Transport en commun',
  in_family: 'Habite à la maison',
  choose_a_status: 'Choissisez un statut',
  active: 'Active',
  archived: 'Archivé',
  yes: 'Oui',
  street: 'Adresse',
  number: 'Numéro',
  bus: 'Boîte',
  zip_postal_code: 'Code postale',
  city: 'Ville/Commune',
  country: 'Pays',
  email: 'Addresse mail',
  change_password: 'Changer le mot passe',
  confirm_password: 'Confirmer le mot passe',
  user_is_finalized: 'Votre compte est pret',
  select_to_add_a_tag: 'Sélectionnez un marqueur',
  select_to_add_a_perk: 'Sélectionnez un privilège',
  tag: 'Marqueur',
  perk: 'Privilège',
  description: 'Déscription',
  log_in: 'Se connecter',
  company_details: 'Les données de l\'entreprise',
  company_info: 'Information de l\'entreprise',
  company_name: 'Nom de l\'entreprise',
  company_logo: 'Logo de l\'entreprise',
  user_settings: 'Paramètres de l\'utilisateur',
  save_company: 'Sauvegarder l\'entreprise',
  cancel: 'Annuler',
  save: 'Sauvegarder',
  create_new_tag: 'Créé un nouveau marqueur',
  create_a_new_perk: 'Créé un nouveau privilège',
  main_user_account: 'L\'utilisateur principal',
  company_setup: 'Configuration de l\'entreprise',
  information: 'Information',
  logo: 'Logo',
  complete_setup: 'Completer la configuration',
  you: 'Toi',
  filter: 'Filtre',
  operator: 'Operateur',
  and: 'Et',
  or: 'Ou',
  not: 'Ne pas',
  add_filter: 'Ajouter un filtre',
  clear: 'Supprimer',
  equals: 'Est',
  does_not_equal: 'N\'est pas',
  contains: 'Contient',
  does_not_contain: 'Ne contient pas',
  is_less_than: 'Est moins que',
  is_more_than: 'Est plus que',
  is_near: 'Est près de',
  choose_a_field: 'Selectionnez un champs',
  score_difference_from_company: 'La diffence de score de l\'entreprise',
  score_difference_from_team: 'La difference de score d\'une équipe',
  role: 'Rôle',
  lowest: 'Le plus bas',
  highest: 'Le plus haut',
  start_of_employment: 'L\'entrée en fonction',
  end_of_employment: 'Fin de l\'emploi',
  reason_for_termination: 'La raison de la résiliation',
  team_fields: 'Champs de l\'équipe',
  user_fields: 'Champs de l\'utilisateur',
  title: 'Titre',
  seniority: 'Ancienneté',
  mode_of_transport: 'Mode de transport',
  children: 'Enfants',
  value: 'Valeur',
  user_list: 'Utilisateurs',
  first: 'Première',
  last: 'Finale',
  last_evaluation: 'Dernière évaluation',
  team_overview: 'Aperçu de l\'équipe',
  add_team: 'Ajouter un équipe ',
  saved_filters: 'Les filtres sauvegardés',
  users: 'Ulitisateurs',
  edit_team: 'Modifier l\'equipe',
  image: 'Image',
  team_name: 'Nom de l\équipe',
  parent_team: 'Bovenliggend team',
  managed_by: 'Géré par',
  members: 'Membres',
  close: 'Fermer',
  add_team_manager: 'Ajouter un manager',
  add_team_member: 'Ajouter un membre',
  professional: 'Professionelle',
  employment: 'Emploi',
  add_user: 'Ajouter un utilisateur',
  posted_draft: 'Un brouillon enregistré',
  posted_final: 'Vitamines envoyées',
  reviewed_submission: 'Vitamines revisée',
  edited_company: 'Modifié l\'entreprise',
  edited_user: 'Modifié l\'utilisateur',
  edited_team: 'Modifié l\'équipe',
  edited_team_members: 'Modifié les membres de l\'équipe',
  added_team_member: 'Membre ajouté',
  removed_team_member: 'Membre supprimé',
  created_team: 'Ajouté l\'équipe',
  added_child: 'Ajouté un enfant',
  create_a_team: 'Cree un équipe',
  drop_your_image_here: 'Posez votre image ici',
  none: 'Aucun',
  testing: 'Tester',
  password: 'Mot de passe',
  cannot_be_empty: 'Veuillez remplir ce champ',
  email_is_not_valid: 'L\'adresse mail n\'est pas correcte',
  password_needs_to_be_at_least_characters_long: 'Votre mot de passe doit contenir au moins (length) charactères',
  passwords_do_not_match: 'Les mot de passe sont differents',
  target_server_full: 'Target server already contains users. Cannot create new main user.',
  reset_password: 'Réinitialiser mot de passe',
  confirm_reset: 'Confirmer',
  this_page_does_not_exist: 'La page n\'existe pas',
  back_to_homepage: 'Retourner à l\'accueille',
  forgot_your_password: 'Avez-vous oublié votre mot de passe?',
  team_score: 'Score de l\'équipe',
  company_score: 'Score de l\'entreprise',
  saved_filter: 'Filtre sauvegardé',
  created_user: 'Utilisateur créé',
  edited_child: 'Enfant modifié',
  type_delete_to_confirm: 'Tapez \'DELETE\' pour confirmer l\'action',
  delete_team: 'Supprimer l\'équipe',
  warning_this_cannot_be_undone: 'ATTENTION: cet action est incontournable',
  firstname: 'Prénom',
  lastname: 'Nom',
  manage_users: 'Gérer les utilisateurs',
  name: 'Nom',
  submit: 'Enovoyé',
  please_wait: 'Un instant svp',
  vitamins_are_being_loaded: 'Votre vitamines sont en train d\'être récolté',
  is_finalized: 'est pret(e) ',
  back_to_login: 'Retourner à l\'acceuille',
  reset_mail_sent: 'Reset mail à été envoyé',
  no_submissions_yet: 'Vous n\'avez pas encore de vitamines',
  start_first_vitamin: 'Commencez par remplir le questionnaire',
  country_AD: 'Andorre',
  country_AE: 'Émirats Arabes Unis',
  country_AF: 'Afghanistan',
  country_AG: 'Antigua-Et-Barbuda',
  country_AI: 'Anguilla',
  country_AL: 'Albanie',
  country_AM: 'Arménie',
  country_AO: 'Angola',
  country_AQ: 'Antarctique',
  country_AR: 'Argentine',
  country_AS: 'Samoa Américaines',
  country_AT: 'Autriche',
  country_AU: 'Australie',
  country_AW: 'Aruba',
  country_AX: 'Åland, Îles',
  country_AZ: 'Azerbaïdjan',
  country_BA: 'Bosnie-Herzégovine',
  country_BB: 'Barbade',
  country_BD: 'Bangladesh',
  country_BE: 'Belgique',
  country_BF: 'Burkina Faso',
  country_BG: 'Bulgarie',
  country_BH: 'Bahreïn',
  country_BI: 'Burundi',
  country_BJ: 'Bénin',
  country_BL: 'Saint-Barthélemy',
  country_BM: 'Bermudes',
  country_BN: 'Brunéi Darussalam',
  country_BO: 'Bolivie, État Plurinational De',
  country_BQ: 'Bonaire, Saint-Eustache Et Saba',
  country_BR: 'Brésil',
  country_BS: 'Bahamas',
  country_BT: 'Bhoutan',
  country_BV: 'Bouvet, Île',
  country_BW: 'Botswana',
  country_BY: 'Bélarus',
  country_BZ: 'Belize',
  country_CA: 'Canada',
  country_CC: 'Cocos (Keeling), Îles',
  country_CD: 'Congo, République Démocratique Du',
  country_CF: 'Centrafricaine, République',
  country_CG: 'Congo',
  country_CH: 'Suisse',
  country_CI: 'Côte D’Ivoire',
  country_CK: 'Cook, Îles',
  country_CL: 'Chili',
  country_CM: 'Cameroun',
  country_CN: 'Chine',
  country_CO: 'Colombie',
  country_CR: 'Costa Rica',
  country_CU: 'Cuba',
  country_CV: 'Cabo Verde',
  country_CW: 'Curaçao',
  country_CX: 'Christmas, Île',
  country_CY: 'Chypre',
  country_CZ: 'Tchéquie',
  country_DE: 'Allemagne',
  country_DJ: 'Djibouti',
  country_DK: 'Danemark',
  country_DM: 'Dominique',
  country_DO: 'Dominicaine, République',
  country_DZ: 'Algérie',
  country_EC: 'Équateur',
  country_EE: 'Estonie',
  country_EG: 'Égypte',
  country_EH: 'Sahara Occidental',
  country_ER: 'Érythrée',
  country_ES: 'Espagne',
  country_ET: 'Éthiopie',
  country_FI: 'Finlande',
  country_FJ: 'Fidji',
  country_FK: 'Falkland, Îles (Malvinas)',
  country_FM: 'Micronésie, États Fédérés De',
  country_FO: 'Féroé, Îles',
  country_FR: 'France',
  country_GA: 'Gabon',
  country_GB: 'Royaume-Uni',
  country_GD: 'Grenade',
  country_GE: 'Géorgie',
  country_GF: 'Guyane Française',
  country_GG: 'Guernesey',
  country_GH: 'Ghana',
  country_GI: 'Gibraltar',
  country_GL: 'Groenland',
  country_GM: 'Gambie',
  country_GN: 'Guinée',
  country_GP: 'Guadeloupe',
  country_GQ: 'Guinée Équatoriale',
  country_GR: 'Grèce',
  country_GS: 'Géorgie Du Sud Et Les Îles Sandwich Du Sud',
  country_GT: 'Guatemala',
  country_GU: 'Guam',
  country_GW: 'Guinée-Bissau',
  country_GY: 'Guyana',
  country_HK: 'Hong Kong',
  country_HM: 'Heard Et Macdonald, Îles',
  country_HN: 'Honduras',
  country_HR: 'Croatie',
  country_HT: 'Haïti',
  country_HU: 'Hongrie',
  country_ID: 'Indonésie',
  country_IE: 'Irlande',
  country_IL: 'Israël',
  country_IM: 'Île De Man',
  country_IN: 'Inde',
  country_IO: 'Océan Indien, Territoire Britannique De L\'',
  country_IQ: 'Iraq',
  country_IR: 'Iran, République Islamique D\'',
  country_IS: 'Islande',
  country_IT: 'Italie',
  country_JE: 'Jersey',
  country_JM: 'Jamaïque',
  country_JO: 'Jordanie',
  country_JP: 'Japon',
  country_KE: 'Kenya',
  country_KG: 'Kirghizistan',
  country_KH: 'Cambodge',
  country_KI: 'Kiribati',
  country_KM: 'Comores',
  country_KN: 'Saint-Kitts-Et-Nevis',
  country_KP: 'Corée, République Populaire Démocratique De',
  country_KR: 'Corée, République De',
  country_KW: 'Koweït',
  country_KY: 'Caïmanes, Îles',
  country_KZ: 'Kazakhstan',
  country_LA: 'Lao, République Démocratique Populaire',
  country_LB: 'Liban',
  country_LC: 'Sainte-Lucie',
  country_LI: 'Liechtenstein',
  country_LK: 'Sri Lanka',
  country_LR: 'Libéria',
  country_LS: 'Lesotho',
  country_LT: 'Lituanie',
  country_LU: 'Luxembourg',
  country_LV: 'Lettonie',
  country_LY: 'Libye',
  country_MA: 'Maroc',
  country_MC: 'Monaco',
  country_MD: 'Moldavie',
  country_ME: 'Monténégro',
  country_MF: 'Saint-Martin (Partie Française)',
  country_MG: 'Madagascar',
  country_MH: 'Marshall, Îles',
  country_MK: 'République De Macédoine',
  country_ML: 'Mali',
  country_MM: 'Myanmar',
  country_MN: 'Mongolie',
  country_MO: 'Macao',
  country_MP: 'Mariannes Du Nord, Îles',
  country_MQ: 'Martinique',
  country_MR: 'Mauritanie',
  country_MS: 'Montserrat',
  country_MT: 'Malte',
  country_MU: 'Maurice',
  country_MV: 'Maldives',
  country_MW: 'Malawi',
  country_MX: 'Mexique',
  country_MY: 'Malaisie',
  country_MZ: 'Mozambique',
  country_NA: 'Namibie',
  country_NC: 'Nouvelle-Calédonie',
  country_NE: 'Niger',
  country_NF: 'Norfolk, Île',
  country_NG: 'Nigéria',
  country_NI: 'Nicaragua',
  country_NL: 'Pays-Bas',
  country_NO: 'Norvège',
  country_NP: 'Népal',
  country_NR: 'Nauru',
  country_NU: 'Niué',
  country_NZ: 'Nouvelle-Zélande',
  country_OM: 'Oman',
  country_PA: 'Panama',
  country_PE: 'Pérou',
  country_PF: 'Polynésie Française',
  country_PG: 'Papouasie-Nouvelle-Guinée',
  country_PH: 'Philippines',
  country_PK: 'Pakistan',
  country_PL: 'Pologne',
  country_PM: 'Saint-Pierre-Et-Miquelon',
  country_PN: 'Pitcairn',
  country_PR: 'Porto Rico',
  country_PS: 'État De Palestine',
  country_PT: 'Portugal',
  country_PW: 'Palaos',
  country_PY: 'Paraguay',
  country_QA: 'Qatar',
  country_RE: 'Réunion',
  country_RO: 'Roumanie',
  country_RS: 'Serbie',
  country_RU: 'Russie, Fédération De',
  country_RW: 'Rwanda',
  country_SA: 'Arabie Saoudite',
  country_SB: 'Salomon, Îles',
  country_SC: 'Seychelles',
  country_SD: 'Soudan',
  country_SE: 'Suède',
  country_SG: 'Singapour',
  country_SH: 'Sainte-Hélène, Ascension Et Tristan Da Cunha',
  country_SI: 'Slovénie',
  country_SJ: 'Svalbard Et Île Jan Mayen',
  country_SK: 'Slovaquie',
  country_SL: 'Sierra Leone',
  country_SM: 'Saint-Marin',
  country_SN: 'Sénégal',
  country_SO: 'Somalie',
  country_SR: 'Suriname',
  country_SS: 'Soudan Du Sud',
  country_ST: 'Sao Tomé-Et-Principe',
  country_SV: 'El Salvador',
  country_SX: 'Saint-Martin (Partie Néerlandaise)',
  country_SY: 'Syrienne, République Arabe',
  country_SZ: 'Eswatini',
  country_TC: 'Turks Et Caïques, Îles',
  country_TD: 'Tchad',
  country_TF: 'Terres Australes Françaises',
  country_TG: 'Togo',
  country_TH: 'Thaïlande',
  country_TJ: 'Tadjikistan',
  country_TK: 'Tokelau',
  country_TL: 'Timor-Leste',
  country_TM: 'Turkménistan',
  country_TN: 'Tunisie',
  country_TO: 'Tonga',
  country_TR: 'Turquie',
  country_TT: 'Trinité-Et-Tobago',
  country_TV: 'Tuvalu',
  country_TW: 'Taïwan',
  country_TZ: 'Tanzanie, République Unie De',
  country_UA: 'Ukraine',
  country_UG: 'Ouganda',
  country_UM: 'Îles Mineures Éloignées Des États-Unis',
  country_US: 'États-Unis',
  country_UY: 'Uruguay',
  country_UZ: 'Ouzbékistan',
  country_VA: 'Saint-Siège (État De La Cité Du Vatican)',
  country_VC: 'Saint-Vincent-Et-Les-Grenadines',
  country_VE: 'Venezuela, République Bolivarienne Du',
  country_VG: 'Îles Vierges Britanniques',
  country_VI: 'Îles Vierges Des États-Unis',
  country_VN: 'Viet Nam',
  country_VU: 'Vanuatu',
  country_WF: 'Wallis-Et-Futuna',
  country_WS: 'Samoa',
  country_YE: 'Yémen',
  country_YT: 'Mayotte',
  country_ZA: 'Afrique Du Sud',
  country_ZM: 'Zambie',
  country_ZW: 'Zimbabwe',
  go_to_user_management: 'Gérer les utilisateurs',
  are_you_sure: 'Est-ce que vous êtes sur?',
  employment_active: 'Actuellement employé',
  delete: 'Supprimer',
  Number: 'Numéro',
  Bus: 'Boîte',
  zipcode: 'Code postale',
  must_be_alphanumeric: 'Ce champs ne peut contenir que des caractères alphanumériques',
  select_a_filter: 'Choissisez un filtre',
  filter_name_empty: 'Ce champs ne peut pas être vide',
  delete_filter: 'Supprimer le filtre',
  settings: 'Paramètres',
  email_or_password_invalid: 'L\'adresse mail ou mot de passe n\'est pas correcte.',
  please_provide_password: 'Entrez votre mot de passe',
  delete_child: 'Supprimer l\'enfant',
  add_comment_question: 'Ajoutez une remarque ou question.',
  language: 'Language',
  user_search_result: '{amt} utilisateurs trouvés',
  recent_users: 'Showing recent users',
  find_a_user: 'Chercher des utilisateurs',
  user: 'Utilisateur',
  managers: 'Managers',
  user_vitamins_are_being_loaded: 'Chargement des Vitamines',
  user_no_submissions_yet: 'Cet utilisateur n\'a pas encore soumis des Vitamines',
  back_to_users: 'Retourner au liste d\'utilisateurs',
  status: 'Statut',
  teams: 'Équipes',
  oneens_eens_1: 'Pas du tout d\'accord',
  oneens_eens_2: 'Pas d\'accord',
  oneens_eens_3: 'Plutôt pas d\'accord',
  oneens_eens_4: 'Ni en désaccord ni d\'accord',
  oneens_eens_5: 'Plutôt d\'accord',
  oneens_eens_6: 'D\'accord',
  oneens_eens_7: 'Tout à fait d\'accord',
  nooit_altijd_1: 'Jamais',
  nooit_altijd_2: 'Occasionnellement',
  nooit_altijd_3: 'Parfois',
  nooit_altijd_4: 'Régulièrement',
  nooit_altijd_5: 'Souvent',
  nooit_altijd_6: 'Très souvent',
  nooit_altijd_7: 'Toujours',
  ontevreden_tevreden_1: 'Totalement insatisfait',
  ontevreden_tevreden_2: 'Insatisfait',
  ontevreden_tevreden_3: 'Plutôt insatisfait',
  ontevreden_tevreden_4: 'Ni satisfait ni insatisfait',
  ontevreden_tevreden_5: 'Plutôt satisfait',
  ontevreden_tevreden_6: 'Satisfait',
  ontevreden_tevreden_7: 'Entièrement satisfait',
  view: 'Examiner',
  review: 'Discuter',
  tree: 'Structure',
  heatmap: 'Heat map',
  activity: 'Activité',
  vip: 'VIP',
  stddev: 'Écart type',
  delete_user: 'Supprimer l\'utilisateur',
  comment_placeholder: 'Ici vous pouvez noter des questions ou des remarques concernant {subcategory}',
  vitamin_overview_for: 'Vitamines pour {username}',
  back_to_userlist: 'Retourner au vue de l\'utilisateur.',
  unknown: 'Inconnu',
  years_seniority: 'Ancienneté',
  workingyears: 'Ancienneté',
  demographics: 'Données démographiques',
  show_results_by_demographic: 'Resultats par démographie',
  choose_a_demographic: 'Selectionnez une catégorie',
  hide_submission: 'Visibilité de la soumission',
  passwords_no_match: 'Les mots de passe ne correspondent pas',
  add_as_member: 'Ajoutez l\'utilisateur à l\'équipe comme membre',
  add_as_manager: 'Ajoutez l\'utilisateur à l\'équipe come manager',
  no_results_yet: 'Il n\'y a pas encore de données disponibles',
  password_min_6_long: 'Votre mot de passe doit contenir au moins six caractères.',
  accesslevel: 'Niveau d\'accès',
  import_users: 'Importer les utilisateurs',
  download_template: 'Téléchargez un modèle',
  first_x_records: 'Premiers {amt} enregistrements',
  maritalstatus: 'État civil',
  Street: 'Rue',
  stateprovince: 'État/province',
  jobtitle: 'Désignation d\'emploi',
  employmentstart: 'Le début de la période d\'emploi',
  employmentend: 'La fin de la période d\'emploi',
  terminationreason: 'La raisoin pour la termination de l\'emploi',
  degreelevel: 'Education',
  modeoftransport: 'Mode de transport',
  x_invalid_rows: '{amt} rangées invalides',
  $ERR_REQ: 'Ce champs ne peut pas être vide!',
  $ERR_DATE: 'Date erronnée!',
  $ERR_INVALID:'Invalid!',
  x_records_processed:'{amt} enregistrements traités',
  x_users_imported_successfully:'{amt} utilisateurs ont été ajouter avec succes',
  x_users_could_not_be_imported:'{amt} d\'utilisateurs n\'ont pas été ajouter.',
  the_following_errors_occurred:'Les erreurs suivantes se sont produites',
  row:'Rangée',
  click_to_add_csv:'Chargement via un ficher .csv',
  must_be_dmyyyy_or_iso:'Format de date: JJ/MM/AAAA ou ISO',
  field_value_restrictions:'La valeur remplie doit être une des suivantes: {values}',
  invalid_country:'Doit être un code pays en format ISO 3166 (alpha) 2',
  misc_server_error: 'Il s\'est produit une erreur',
  emailtaken_server_error: 'Cet adress mail a déjà été utilisé.',
  seniority_entry:'Niveau débutant',
  seniority_mid:'Niveau intermédiair',
  seniority_senior:'Niveau supérieur',
  member_of:'Member de',
  admin_of:'Admin de',
  manager_of:'Manager de',
  remove_from_team:'Supprimer de l\'équipe',
  expand_all: 'Développer tout',
  collapse_all: 'Réduire tout',
};

export default {
  message
}



// WEBPACK FOOTER //
// ./src/fr.js